"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var FocusEnableButton_1 = __importDefault(require("./FocusEnableButton"));
var FocusDisableButton_1 = __importDefault(require("./FocusDisableButton"));
var IntegrationFocus = (function () {
    function IntegrationFocus(createUi, make, account, isEnabled, Button, integration, overlayStack, telemetry, onClose, integrationService) {
        var _this = this;
        this.overlayStack = overlayStack;
        this.onClose = onClose;
        var customEnableScreen;
        var integrationCtrl = {};
        var name = integration.internalName;
        if (account.integrations[name] == null) {
            account.integrations[name] = {};
        }
        if (account.integrations[name].settings == null) {
            account.integrations[name].settings = {};
        }
        if (account.integrations[name].enabled == null) {
            account.integrations[name].enabled = false;
        }
        if (integration.ctrl != null) {
            integrationCtrl = make(integration.ctrl, {
                settings: account.integrations[name].settings || {},
                isEnabled: isEnabled,
            });
        }
        if (integration.customEnableScreen != null) {
            customEnableScreen = make(integration.customEnableScreen, {
                needsUpselling: integrationService.needsUpselling(integration),
            });
        }
        else {
            customEnableScreen = {};
        }
        var friendlyErrorMessage = "We encountered an error. Please try again later, or contact our support.";
        var enable = function () {
            if (integrationCtrl.enable != null) {
                _this.ui.isLoading = true;
                return integrationCtrl
                    .enable()
                    .then(function () {
                    _this.ui.error = null;
                    _this.ui.isLoading = false;
                    telemetry.trackOnly("Integration Enabled", { integration_name: integration.name });
                })
                    .catch(function (response) {
                    var _a, _b, _c, _d;
                    _this.ui.isLoading = false;
                    _this.ui.error = friendlyErrorMessage;
                    if (((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.type) !== "DownstreamServiceError" && ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.message)) {
                        _this.ui.error = response.data.error.message;
                    }
                });
            }
            else {
                return Promise.resolve();
            }
        };
        var disable = function () {
            if (_this.ui.isEnabled()) {
                if (integrationCtrl.disable != null) {
                    _this.ui.isLoading = true;
                    return integrationCtrl
                        .disable()
                        .then(function () {
                        _this.ui.error = null;
                        _this.ui.isLoading = false;
                        telemetry.trackOnly("Integration Disabled", { integration_name: integration.name }, { blockIntercom: true });
                    })
                        .catch(function (response) {
                        var _a, _b, _c, _d;
                        _this.ui.isLoading = false;
                        _this.ui.error = friendlyErrorMessage;
                        if (((_b = (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 ? void 0 : _b.type) !== "DownstreamServiceError" && ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.error) === null || _d === void 0 ? void 0 : _d.message)) {
                            _this.ui.error = response.data.error.message;
                        }
                    });
                }
            }
        };
        var enableButton = make(FocusEnableButton_1.default, {
            enable: enable,
        });
        var disableButton = make(FocusDisableButton_1.default, {
            disable: disable,
        });
        this.ui = createUi(require("./Focus.html"), {
            integration: integration,
            inOverlay: false,
            hasMarketingDetails: integration.overview != null || integration.features != null,
            logoStyle: {
                "background-image": "url(\"".concat(integration.headerLogo || integration.logo, "\")"),
                "border-radius": integration.circleIcon ? "100%" : "0",
            },
            hasCustomEnableScreen: integration.customEnableScreen != null,
            enableButton: enableButton.ui,
            disableButton: disableButton.ui,
            shouldShowEnableButtonNotes: function () {
                if (!integration.enableButtonNotes) {
                    return false;
                }
                return integration.enableButtonNotes.getText() && !isEnabled();
            },
            customEnableScreen: customEnableScreen.ui,
            content: integrationCtrl != undefined ? integrationCtrl.ui : undefined,
            enablingContent: integrationCtrl != undefined ? integrationCtrl.enablingUi : undefined,
            additionalSettings: integrationCtrl != undefined ? integrationCtrl.additionalSettingsUi : undefined,
            onboardingBanner: integrationCtrl != undefined ? integrationCtrl.onboardingBannerUi : undefined,
            isEnabled: function () {
                return isEnabled() && !_this.ui.isEnabling();
            },
            isDisabled: function () {
                return !isEnabled() && !_this.ui.isEnabling();
            },
            isEnabling: function () {
                return _this.ui.isLoading;
            },
            isLoading: false,
        });
        this.enable = enable;
    }
    IntegrationFocus.prototype.show = function () {
        this.ui.inOverlay = true;
        this.overlayStack.add({
            contentUi: this.ui,
            options: {
                className: "settings-focus-overlay",
                onClose: this.onClose,
            },
        });
    };
    return IntegrationFocus;
}());
exports.default = IntegrationFocus;
